import * as Config from '../../../../config';
import React from "react";
import { useSelector, useDispatch } from "react-redux";

import IconRename from '../svg/IconRename';
import IconRemove from '../svg/IconRemove';
import IconRedirect from '../svg/IconRedirect';
import IconDuplicate from '../svg/IconDuplicate';

import { MenuItem } from "react-contextmenu";
import { setContextMenu } from "../../../../actions/index";
import usePlaylistMenu from '../../../../hooks/usePlaylistMenu';

const useFullPlaylistMenu = (playlist) => {

  const { id } = playlist;
  const to = `/playlists/${id}`;
  const cover = (playlist.covers) ? playlist.covers : ((playlist.release_images && playlist.release_images.length > 0) ? playlist.release_images : [Config.DEFAULT_IMG]);
  const isConnected = useSelector(state => state.isConnected);
  const dispatch = useDispatch();

  const {
    match, setHistory,
    availableDrop, opacity, refDrop,
    updateFormPlaylist, deleteFormPlaylist, duplicateFormPlaylist, toStore
  } = usePlaylistMenu(playlist, to, isConnected);

  const showContextMenu = () => {
    let menu = [
      <MenuItem key={`uPlaylist`} onClick={updateFormPlaylist} data={{ action: 'Updated' }}>
        <div className={'flexRow block-contextmenu-item all-hover-fill'}>
          <IconRename />
          {`Rename playlist`}
        </div>
      </MenuItem>,
      <MenuItem key={`dPlaylist`} onClick={deleteFormPlaylist} data={{ action: 'Deleted' }}>
        <div className={'flexRow block-contextmenu-item'}>
          <IconRemove />
          {`Delete playlist`}
        </div>
      </MenuItem>,
    ];
    if (isConnected) {
      menu.push(
        <MenuItem key={`cPlaylist`} onClick={duplicateFormPlaylist} data={{ action: 'Duplicate' }}>
          <div className={'flexRow block-contextmenu-item all-hover'}>
            <IconDuplicate />
            {`Duplicate playlist`}
          </div>
        </MenuItem>
      );
    }
    if (Config.ACCESS_STORE && isConnected) {
      menu.push(
        <MenuItem key={`toStore`} onClick={toStore} data={{ action: 'To' }}>
          <div className={'flexRow block-contextmenu-item all-hover'}>
            <IconRedirect />
            {`View on ${Config.capAppName()}`}
          </div>
        </MenuItem>
      );
    }
    dispatch(setContextMenu(menu,{className: 'dynamic-menu-playlist-menu'}));
  }
  const onRightClick = (e) => {
    const el = document.getElementById(`more-ref-${id}`);
    (el) && el.click();
  }

  return {
    match, setHistory,
    availableDrop, opacity, refDrop,
    updateFormPlaylist, deleteFormPlaylist, duplicateFormPlaylist, toStore,
    id, to, cover, showContextMenu, onRightClick
  };
};

export default useFullPlaylistMenu;
